export default __webpack_public_path__ + "static/media/ImgReleased.813aee19.png";